import { WaterLevel, WaterLevelObservation } from '../../waterLevel.types';
import { useWaterLevel } from '../useWaterLevel';
import { useWaterLevelObservations } from '../useWaterLevelObservations';

type UseWaterLevelWithObservationsProps = {
  id: number;
  start: Date;
  end: Date;
  pollInterval?: number;
};

type UseWaterLevelWithObservations = {
  waterLevel?: WaterLevel;
  observations: WaterLevelObservation[];
  forecasts: WaterLevelObservation[];
  isLoading: boolean;
  isLoadingStation: boolean;
  isLoadingObservations: boolean;
  isLoadingForecasts: boolean;
  error: Error | null;
};

export const useWaterLevelWithObservations = (
  props: UseWaterLevelWithObservationsProps,
): UseWaterLevelWithObservations => {
  const { id, start, end, pollInterval } = props;

  const {
    waterLevel,
    isLoading: isLoadingStation,
    error: waterLevelError,
  } = useWaterLevel({ id });

  const {
    observations = [],
    forecasts = [],
    isLoadingObservations,
    isLoadingForecasts,
    error: observationsError,
  } = useWaterLevelObservations({ id, start, end, pollInterval });

  return {
    waterLevel,
    observations,
    forecasts,
    isLoading: isLoadingStation || isLoadingObservations || isLoadingForecasts,
    isLoadingStation,
    isLoadingObservations,
    isLoadingForecasts,
    error: waterLevelError || observationsError,
  };
};
